
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Vashitopunecabs() {



    const cardData =
    {
        keyword: 'Vashi to Pune Cab  ',
        heading: 'Mauli Cabs: Vashi to Pune Cab  ',
        headingDescription: 'Mauli Cabs offers smooth and reliable Vashi to Pune cab services, ensuring a comfortable and stress-free journey from Navi Mumbai’s key commercial hub to your destination in Pune. Whether you are traveling for work, leisure, or a family outing, we provide a fleet of well-maintained vehicles including sedans, SUVs, and premium cabs tailored to your needs. With professional drivers, on-time service, transparent pricing, and no hidden charges, Mauli Cabs guarantees a safe and enjoyable ride from Vashi to Pune.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located about 30 km from Pune, Sinhagad Fort is a favorite spot for trekking and offers panoramic views and a rich historical background."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganesh temples in Maharashtra, this temple is revered for its magnificent idol and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Parvati Hill",
        "description": "Parvati Hill offers a serene temple complex atop a hill with beautiful views of the city and is one of the oldest heritage sites in Pune."
    },
    {
        "title": "Osho Garden and Ashram",
        "description": "Located in Koregaon Park, this peaceful garden and spiritual center draws global visitors for meditation and relaxation in tranquil surroundings."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum showcases a fascinating collection of artifacts, including musical instruments, weaponry, and antiques, celebrating India’s cultural heritage."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Inspired by a Japanese design, this beautifully landscaped garden is perfect for calm walks and nature photography."
    },
    {
        "title": "Rajiv Gandhi Zoological Park",
        "description": "Also known as Katraj Zoo, this park houses various species of animals and a dedicated snake park, popular with families and kids."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, this ancient monument offers spiritual solace in the middle of the city."
    }
],

"services": [
    {
      "name": "Vashi to Pune Cab",
      "description": "Book a comfortable cab from Vashi to Pune with professional drivers and multiple vehicle options. Enjoy a safe and reliable ride at fair prices."
    },
    {
      "name": "Vashi to Pune Taxi Fare",
      "description": "Get transparent and affordable taxi fare from Vashi to Pune. Choose from a range of vehicles to suit your travel preferences and budget."
    },
    {
      "name": "Vashi to Pune Taxi Service",
      "description": "Travel hassle-free from Vashi to Pune with our dependable taxi service. Clean vehicles, courteous drivers, and timely service guaranteed."
    },
    {
      "name": "Vashi to Pune One Day Cab",
      "description": "Plan a one-day round trip from Vashi to Pune with our efficient cab service. Ideal for quick business or personal travel."
    },
    {
      "name": "Vashi to Pune Round Trip Cab",
      "description": "Book a round trip cab from Vashi to Pune and back with ease. Affordable rates and comfortable travel experience included."
    },
    {
      "name": "Vashi to Pune Ertiga Cab",
      "description": "Travel in comfort from Vashi to Pune in an Ertiga. Spacious and ideal for families or small groups with budget-friendly pricing."
    },
    {
      "name": "Vashi to Pimpri Chinchwad Cab",
      "description": "Book a cab from Vashi to Pimpri Chinchwad with professional service and transparent pricing. Multiple vehicle options available."
    },
    {
      "name": "Vashi to Wanowrie Cab",
      "description": "Travel from Vashi to Wanowrie in Pune with ease. Enjoy smooth and affordable cab rides with reliable service."
    },
    {
      "name": "Vashi to Pune Sedan Cab",
      "description": "Choose a sedan cab from Vashi to Pune for a budget-friendly and comfortable ride. Clean vehicles and courteous drivers included."
    },
    {
      "name": "Vashi to Pune Innova Crysta",
      "description": "Book an Innova Crysta from Vashi to Pune for a luxurious travel experience. Spacious and perfect for group or family travel."
    },
    {
      "name": "Vashi to Aundh Cab",
      "description": "Get a cab from Vashi to Aundh, Pune, with timely pickups and fair pricing. Choose from sedans, SUVs, and more."
    },
    {
      "name": "Cab Service in Vashi",
      "description": "Reliable cab services in Vashi for both local and outstation trips. A wide range of vehicles and professional drivers at your service."
    },
    {
      "name": "Vashi to Pune Station Cabs Service",
      "description": "Book a cab from Vashi to Pune Railway Station with ease. Transparent fares and dependable service for a stress-free ride."
    }
  ],
  "tableData": [
    ["Vashi to Pune Cab", "Vashi to Pune Taxi Fare"],
    ["Vashi to Pune Taxi Service", "Vashi to Pune One Day Cab"],
    ["Vashi to Pune Round Trip Cab", "Vashi to Pune Ertiga Cab"],
    ["Vashi to Pimpri Chinchwad Cab", "Vashi to Wanowrie Cab"],
    ["Vashi to Pune Sedan Cab", "Vashi to Pune Innova Crysta"],
    ["Vashi to Aundh Cab", "Cab Service in Vashi"],
    ["Vashi to Pune Station Cabs Service", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Trusted Cab Service from Vashi to Pune",
        "WhyChoosedescription": "Mauli Cabs offers a professional and reliable cab service from Vashi to Pune, ensuring you travel in comfort and reach your destination on time, every time."
    },
    {
        "WhyChooseheading": "Clean and Comfortable Vehicles",
        "WhyChoosedescription": "Enjoy a smooth ride in our clean, air-conditioned sedans, SUVs, and premium cars. All our vehicles are spacious, regularly sanitized, and perfect for long-distance travel."
    },
    {
        "WhyChooseheading": "Experienced Drivers for a Smooth Journey",
        "WhyChoosedescription": "Our skilled drivers are familiar with the Vashi to Pune route, using the best paths to avoid traffic and ensuring a safe and efficient travel experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "With Mauli Cabs, you get clear and competitive pricing. No hidden charges—just straightforward rates that match the quality of our service from Vashi to Pune."
    },
    {
        "WhyChooseheading": "24/7 Service Availability",
        "WhyChoosedescription": "Whether it’s a late-night pickup or an early morning departure, our Vashi to Pune cab services are available 24/7 to meet your travel needs anytime."
    },
    {
        "WhyChooseheading": "Instant Booking with Live Updates",
        "WhyChoosedescription": "Book your cab instantly through our website or app and track your ride in real-time. Get timely updates on driver location, ETA, and trip status."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel Experience",
        "WhyChoosedescription": "Your safety is our priority. All cabs are GPS-enabled, sanitized thoroughly, and operated by background-verified drivers who follow all safety protocols."
    },
    {
        "WhyChooseheading": "Multiple Payment Options",
        "WhyChoosedescription": "We offer flexible and secure payment methods including UPI, credit/debit cards, wallets, and cash—choose whatever suits you best."
    }
]










    }

    const faqData = [
        {
            question: 'How do I book a cab from Vashi to Pune with Mauli Cabs?',
            answer: 'To book a cab from Vashi to Pune, simply visit the Mauli Cabs website or app. Enter "Vashi" as your pickup point and "Pune" as your destination. Select your preferred cab type, confirm the booking, and you are all set. Our support team is available 24/7 for any help you may need.',
        },
        {
            question: 'What types of cabs are available for the Vashi to Pune route?',
            answer: 'Mauli Cabs provides multiple options for travel from Vashi to Pune, including Hatchbacks, Sedans, SUVs, Ertiga, Innova Crysta, and premium cars. Choose the vehicle that best suits your comfort, budget, and luggage needs.',
        },
        {
            question: 'Is the fare fixed for the Vashi to Pune cab service?',
            answer: 'Yes, Mauli Cabs offers fixed fares for Vashi to Pune cabs. The price includes tolls, fuel, taxes, and driver charges. There are no hidden costs, and the total fare is shown before booking confirmation.',
        },
        {
            question: 'How long does the journey from Vashi to Pune take?',
            answer: 'The typical travel time from Vashi to Pune is between 3.5 to 4.5 hours, depending on traffic and road conditions. For a more convenient journey, we suggest avoiding peak travel times.',
        },
        {
            question: 'Can I book a one-way or round-trip cab from Vashi to Pune?',
            answer: 'Yes, Mauli Cabs offers both one-way and round-trip bookings. If you are planning to return the same or next day, a round-trip option can offer better value.',
        },
        {
            question: 'Is the Vashi to Pune cab service available at all times?',
            answer: 'Absolutely. Mauli Cabs operates 24/7, ensuring you can travel from Vashi to Pune any time—whether it’s early morning, late night, or anytime in between.',
        },
        {
            question: 'Can I carry extra luggage in the Vashi to Pune cab?',
            answer: 'Yes, extra luggage is allowed. If you are carrying larger or multiple bags, we recommend choosing a spacious vehicle like an SUV or Innova Crysta for a comfortable ride.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Nikhil Bhosale",
            position: "Software Developer",
            text: "I travel often from Vashi to Pune for work, and Mauli Cabs is my go-to choice. The drivers are professional, and the vehicles are always clean and punctual. A very reliable service!",
            image: "/img/testimonial/testimonial-thumb-1-79.png",
        },
        {
            name: "Ms. Rucha Naik",
            position: "Fashion Designer",
            text: "Booked a cab from Vashi to Pune for a weekend getaway. The ride was smooth, the cab was comfortable, and the booking process was super easy. Highly recommend Mauli Cabs!",
            image: "/img/testimonial/testimonial-thumb-1-80.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Vashi to Pune Cab Service",
        "description": "Book a reliable and comfortable cab from Vashi to Pune with Mauli Cabs. Choose from a wide range of vehicles including Innova, Ertiga, and sedan for your journey.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "1520"
        }
      };
      
     
      
   


    return (
        <div>
            <GTag/>


<Helmet>
        <title>Vashi to Pune Cab Service | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book a reliable Vashi to Pune cab with Mauli Cabs. We offer different types of cabs including Innova, Ertiga, and sedan. Perfect for your comfortable journey."
        />
        <meta
          name="keywords"
          content="Vashi to Pune Cab, Vashi to Pune taxi fare, Vashi to Pune taxi service, Vashi to Pune one day cab, Vashi to Pune round trip cab, Vashi to Pune Ertiga cab, Vashi to Pimpri Chinchwad cab, Vashi to Wanowrie cab, Vashi to Pune sedan cab, Vashi to Pune Innova Crysta, Vashi to Aundh cab, Cab Service in Vashi, Vashi to Pune station cabs service"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/123.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Vashitopunecabs;